<template>
    <v-btn
      v-if="buttonTitle"
      :id="articleId"
      :aria-label="articleId"
      v-html="buttonTitle"
      class=" justify-start text-xs-left text-capitalize fill-height mx-2 my-1 fab-text fill-width"
      @click="checkType">
    </v-btn>
</template>

<script>
  import { POST_STUDENT_HELP_POPUP_ARTICLE } from '../../../store/action-types'
  import { mapActions } from 'vuex'

  export default {
    name: 'fab-button',
    props: {
      buttonKey: {
        required: true,
        type: String
      }
    },
    data () {
      return {}
    },
    methods: {
      ...mapActions({
        postHelpPopUpArticle: POST_STUDENT_HELP_POPUP_ARTICLE
      }),
      checkType () {
        this.postHelpPopUpArticle(this.getIdentifier)
        this.$emit('close-help-popup')
        if (this.internalLink) {
          this.$router.push(`/support/${this.buttonKey}`)
        } else {
          window.open(this.getLink, '_blank')
        }
      }
    },
    computed: {
      buttonTitle () {
        return this.$t(`student.help.articles.${this.buttonKey}.title`)
      },
      buttonType () {
        return this.$t(`student.help.articles.${this.buttonKey}.type`)
      },
      internalLink () {
        return this.buttonType === 'internal'
      },
      articleId () {
        return 'student-help-article-' + this.buttonKey
      },
      getIdentifier () {
        let identifier = `student.help.articles.${this.buttonKey}.identifier`
        return this.$i18n.keyExists(identifier) ? this.$t(identifier) : ''
      },
      getLink () {
        let link = `student.help.articles.${this.buttonKey}.link`
        return this.$i18n.keyExists(link) ? this.$t(link) : ''
      }
    }
  }
</script>

<style scoped>
  .fab-text {
    padding: 0.5em 1em;
    margin: 10px 0;
    box-shadow: 0 7px 8px -4px rgba(0,0,0,.2), 0 12px 17px 2px rgba(0,0,0,.14), 0 5px 22px 4px rgba(0,0,0,.12);
  }

  .fill-width {
    width: 100%
  }
</style>



// WEBPACK FOOTER //
// src/components/misc/fab/FabHelpButton.vue